/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const SelectionsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The items to show in the selections list
   */
  items: PropTypes.any.isRequired,

  /**
   * On remove callback
   */
  onRemove: PropTypes.func.isRequired,

  /**
   * On toggle callback
   */
  onToggle: PropTypes.func.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default SelectionsPropTypes;
